import { useState } from 'react';
import Select from 'react-select';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import { useSettings } from 'context/SettingsContext';
import { useTheme } from 'context/ThemeContext';
import { selectStylesDark, selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import type { SelectOption } from '../types';

interface DimensionSelectProps {
    value?: number;
    onChange: (option: SelectOption | null) => void;
    required?: boolean;
}

const DimensionSelect = ({ value, onChange, required = true }: DimensionSelectProps) => {
    const { auth } = useAuth();
    const { darkTheme } = useTheme();
    const { localSettings } = useSettings();
    const [selectTheme] = useState(darkTheme ? selectStylesDark : selectStylesLigth);
    const [options] = useState<SelectOption[]>(
        localSettings?.DIRS.Dimension?.map((dimension: { ID: number; dimensionName: string }) => ({
            value: dimension.ID,
            label: dimension.dimensionName,
        })) || [],
    );

    return (
        <Select<SelectOption>
            options={options}
            styles={{
                ...selectTheme,
                control: (base, state) => ({
                    ...base,
                    ...(selectTheme.control ? selectTheme.control(base, state) : {}),
                }),
            }}
            required={required}
            className="w-100"
            value={options?.find((dimension) => dimension?.value == value) || null}
            onChange={onChange}
            isMulti={false}
            isDisabled={!hasUserAccess(auth?.user, 'prodEdit')}
        />
    );
};

export default DimensionSelect;
